import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { faCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { addDays } from 'date-fns';
import _ from 'lodash';
import moment from 'moment';
//=========================================================================
import { CommonConstant } from 'src/app/constants';

type Moment = moment.Moment;

@Component({
  selector: 'pos-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatepickerComponent implements OnInit {
  @Input() showDatePicker = false;
  // maximum days that user can increase, default unlimited.
  @Input() maxDay: number;

  // maximum days that user can decrease, default unlimited.
  @Input() minDay: number;
  @Input() displayDateFormat = 'ddd, MMMM DD';

  @Input()
  set currentDate(value) {
    this._currentDate = moment(value);
  }

  get currentDate() {
    return this._currentDate;
  }

  @Output() dateChanged = new EventEmitter<string>();

  // count = 0;
  minDate: Date;
  maxDate: Date;

  readonly faCalendar = faCalendar;
  readonly faChevronLeft = faChevronLeft;
  readonly faChevronRight = faChevronRight;

  private _currentDate: Date | Moment;
  get currentDateString() {
    return moment(this.currentDate).format(
      CommonConstant.MOMENT_DATE_TIME.DATE
    );
  }

  ngOnInit() {
    const now = new Date();
    if (!this.currentDate) {
      this.currentDate = now;
    }

    if (!_.isNil(this.minDay)) {
      this.minDate = addDays(now, -this.minDay);
    }

    if (!_.isNil(this.maxDay)) {
      this.maxDate = addDays(now, this.maxDay);
    }
  }

  get dateDisplay() {
    return moment(this.currentDate).format(this.displayDateFormat);
  }

  selectDate(date: Moment) {
    this._currentDate = date;
    // this.formatDateDisplay();
    this.dateChanged.emit(
      (this.currentDate as Moment).format(CommonConstant.MOMENT_DATE_TIME.DATE)
    );
  }

  increase() {
    this.selectDate((this.currentDate as Moment).add(1, 'd'));
  }

  decrease() {
    this.selectDate((this.currentDate as Moment).add(-1, 'd'));
  }

  onDatePickerSelect(event) {
    this.selectDate(event.value);
  }

  getDateDifference(start: Moment, end: Moment) {
    const startDate = start.format(CommonConstant.MOMENT_DATE_TIME.DATE);
    const endDate = end.format(CommonConstant.MOMENT_DATE_TIME.DATE);

    return moment(endDate).diff(moment(startDate), 'days');
  }

  get isMax(): boolean {
    const dateDiff = this.getDateDifference(
      moment(this.currentDate),
      moment(this.maxDate)
    );
    return this.maxDate && dateDiff === 0;
  }

  get isMin(): boolean {
    const dateDiff = this.getDateDifference(
      moment(this.currentDate),
      moment(this.minDate)
    );
    return this.minDate && dateDiff === 0;
  }
}
